import { useRouter } from "next/router";
import React, { ReactElement, useState } from "react";
import { IVendorQuery } from "~/lib/queries/__generated__/VendorQuery.generated";
import { NoSharingPage } from "~/components/profile/EmptyBlocks";
import UpgradeToMakersProBanner from "~/components/vendor/profile/UpgradeToMakersProBanner";
import EditVendorSharingModal from "~/components/vendor/profile/owner/tabs/EditVendorSharingModal";
import VendorSharingPage from "~/components/vendor/profile/owner/tabs/VendorSharingPage";

interface IVendorOwnerSharingTabProps {
  vendor: NonNullable<IVendorQuery["company"]>;
}

export default function VendorOwnerSharingTab({ vendor }: IVendorOwnerSharingTabProps): ReactElement {
  const [isModalShown, setIsModalShown] = useState(false);
  const router = useRouter();

  const openModal = () => {
    setIsModalShown(true);

    return (
      <EditVendorSharingModal
        vendor={vendor}
        isOpen={isModalShown}
        onRequestClose={() => {
          setIsModalShown(!isModalShown);
          return router.push("/vendors/[vendorSlug]/[[...content]]", `/vendors/${vendor.slug}/sharing`);
        }}
      />
    );
  };

  if (!vendor.plan.limits.sharingPage) {
    return <UpgradeToMakersProBanner />;
  }

  if (!vendor.enabledSharing) {
    return (
      <>
        <NoSharingPage onStartSharing={() => setIsModalShown(true)} isForMakers={true} />

        {isModalShown && (
          <EditVendorSharingModal
            vendor={vendor}
            isOpen={isModalShown}
            onRequestClose={() => {
              setIsModalShown(!isModalShown);
              return router.push("/vendors/[vendorSlug]/[[...content]]", `/vendors/${vendor.slug}/sharing`);
            }}
          />
        )}
      </>
    );
  }

  return (
    <>
      <VendorSharingPage vendor={vendor} onGearIconClicked={() => openModal()} />

      {isModalShown && (
        <EditVendorSharingModal
          vendor={vendor}
          isOpen={isModalShown}
          onRequestClose={() => {
            setIsModalShown(!isModalShown);
            return router.push("/vendors/[vendorSlug]/[[...content]]", `/vendors/${vendor.slug}/sharing`);
          }}
        />
      )}
    </>
  );
}
